module.exports = __webpack_public_path__ + "img/C28E4E_845119_0B0805_713C0C-256px.8a0dc3c7.png";